module.exports = __webpack_public_path__ + "23c16435d15fd164c4b860adb262e8ef.png";